import { RoutesMap } from "../common/routes";

export enum Role {
  SUPER_ADMIN = 'Superadministrador',
  ADMIN       = 'Administrador',
  SUPERVISOR  = 'Supervisor',
  MAINTENANCE = 'Jefe de Mantenimiento',
  DRIVER      = 'Conductor',
  MECHANIC    = 'Mecánico',
  ASSISTANT   = 'Ayudante',
  CUSTOMER    = 'Cliente',
  TECHNICAL   = 'Técnico',
}

export const ROUTES_FOR_ADMIN = [
  {
    module: RoutesMap.HOME,
    navigators: []
  },
]
